export const API = 'https://api.lumahealth.io/api';
